import React from 'react';
import { CheckIcon, InfoIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { guides } from '../../data/content';
export function WhatsInside() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" aria-labelledby="inside-title" data-id="element-332" data-mp="1li0he6reo4am">
      <div className="mx-auto max-w-5xl" data-id="element-333" data-mp="1gjyxxkq2i2ym">
        <div id="inside-title" data-id="element-334" data-mp="1ciwusst156rd">
          <SectionHeading eyebrow="What’s inside 5-MIN MENOPAUSE™?" title="A 6-part clinical decision system" subtitle="This isn’t another menopause ebook. It’s built around the actual flow of a patient visit — each guide addresses a different stage of the process." data-id="element-335" data-mp="1cjy8z65ce9db" />
        </div>

        <div className="mt-10 space-y-5" data-id="element-336" data-mp="xngzylkml6tx">
          {guides.map(guide => <article key={guide.number} className="overflow-hidden rounded-3xl border border-navy/10 bg-white" data-id="element-337" data-mp="2wxgsn9k9w41t">
              <div className="border-b border-navy/10 bg-navy px-5 py-4 sm:px-7" data-id="element-338" data-mp="1koojgaa75yfy">
                <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-rose-light" data-id="element-339" data-mp="1kr18t8iabb31">
                  {guide.number}
                </p>
                <h3 className="mt-1 font-display text-[22px] font-bold leading-tight text-white sm:text-[28px]" data-id="element-340" data-mp="1ark16ljh2n4f">
                  {guide.title}
                </h3>
              </div>

              <div className="px-5 py-6 sm:px-7" data-id="element-341" data-mp="23ewfk8fhbomn">
                <p className="font-display text-[17px] font-semibold italic leading-snug text-rose sm:text-xl" data-id="element-342" data-mp="23h93d27x4t7m">
                  {guide.hook}
                </p>
                {guide.description ? <p className="mt-3 text-[14.5px] leading-relaxed text-navy/70 sm:text-[15.5px]" data-id="element-343" data-mp="1tnijybqnf8ys">
                    {guide.description}
                  </p> : null}

                <p className="mt-6 text-[11px] font-extrabold uppercase tracking-[0.12em] text-navy/50" data-id="element-344" data-mp="2mbxlpwkrrus6">
                  Inside:
                </p>
                <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-345" data-mp="310za6vj75il4">
                  {guide.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-346" data-mp="2w2pcad6383vt">
                      <span className="mt-0.5 flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-teal-mist text-teal" aria-hidden="true" data-id="element-347" data-mp="2rzjabhq0cyv5">
                        <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-348" data-mp="2i3fytl99nnvj" />
                      </span>
                      <span className="text-[14px] font-medium leading-snug text-navy/85 sm:text-[15px]" data-id="element-349" data-mp="2d9lj0sws7t1q">
                        {item}
                      </span>
                    </li>)}
                </ul>

                {guide.note ? <p className="mt-5 flex gap-2 rounded-xl bg-sand px-3.5 py-3 text-[12px] leading-snug text-navy/60" data-id="element-350" data-mp="1zbx03qm9yvzb">
                    <InfoIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-351" data-mp="1udbz3oz7889t" />
                    {guide.note}
                  </p> : null}
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-352" data-mp="evfl96nx7e2g">
          <CtaButton label="I want the 6 guides" subtext="All 6 guides + 5 bonuses for a one-time $27" data-id="element-353" data-mp="js62vyfdihpz" />
        </div>
      </div>
    </section>;
}